/* eslint-disable react-native/no-inline-styles */
import React, { forwardRef, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
// import cloneDeep from 'lodash/cloneDeep';
import { Col, Row, Button,Modal } from "react-bootstrap";
// import { IoEyeOutline } from "react-icons/io5";
// import Divider from '@mui/material/Divider';


 import KeyInfoDetails from './KeyInfoDetails';

const PropertyFees = forwardRef(({
  pdpData,
  pdpPropertyFees,
  emd,
  status,
  getbidcenterdata,
  isFcOnlineFlag,
}, ref) => {
  // const [showBuyer, setBuyerShow] = useState(false);
  // const [showEarnestToolTip, setEarnestToolTipShow] = useState(false);
  // const [earnestSelectedIndex, setEarnestSelectedIndex] = useState();
  // const [showTechnology, setTechnology] = useState(false);
  // const [showBuyerPay, setBuyerPay] = useState(false);
  const pdpInitData = useSelector(state => state.pdp?.pdpInitData);

  const {
    propertyId,
    detailedAttributes,
    commonAttributes,
    address,
  } = pdpData?.propertyDetails || {};

  const {
    airConditionCount,
    golfCourseCount,
    clubHouseCount,
    tennisCourtCount,
    backyardCount,
    fireplacesCount,
    basementCount,
    swimmingPoolCount,
    deckPatioCount,
    subdivision,
    parkingCount,
    squareFeet,
    hoaDues,
    hasAc,
    hoaFrequency,
    basementType,
    floorsNum,
    halfBathsNum,
    waterView,
    fullBathsNum,
    numberOfViews,
  } = detailedAttributes || {};


  // const propertyView =
  //   detailedAttributes?.numberOfViews === '2' ? 'View' : 'Views';


  const airCondition = hasAc === false ? 'No' : 'Yes';
  const {
    pdpEnabledFeatures,
    webTransactionFee,
    shortSaleFlag,
    buyerAgentCommissionPercent,
    buyerAgentCommissionAmount,
  } = pdpData?.propertySpecialDetails || {};
  const { listingType } = pdpData?.listingDetail || {};
  const { propCategory } = commonAttributes || {};
  const buyerAgentCommissionText =
    buyerAgentCommissionPercent > 1 && buyerAgentCommissionAmount !== 0
      ? 'Greater of ' +
        buyerAgentCommissionPercent +
        '% of sale price or $' +
        buyerAgentCommissionAmount + '.'
      : buyerAgentCommissionAmount !== 0
      ? '$' + buyerAgentCommissionAmount
      : buyerAgentCommissionPercent > 1
      ? buyerAgentCommissionPercent
      : 'Not Offered';
  const { isPrelistAsset, apnTaxId, isAllowedPreSale } = detailedAttributes;
  const hasAPN = apnTaxId !== '';
  const isPreviewProperty = isAllowedPreSale !== null;

  const beds = commonAttributes?.bedroomsNum;
  const showBid =
    isFcOnlineFlag === 'Y' ||
    (propCategory !== 'FORECLOSURE' &&
      isPrelistAsset !== 'PREVIEW' &&
      listingType !== 'TRNL');



  const hasAtLeastOne = item => item !== '' && parseInt(item, 10) > 0;
  const getBuyersPremimum = () => {
    if (pdpEnabledFeatures && pdpEnabledFeatures.includes('SELLER')) {
      return pdpPropertyFees?.sellerPremiumText;
    } else if (
      pdpData?.revisedBuyerPremium !== undefined &&
      pdpData?.revisedBuyerPremiumPercentage
    ) {
      if (pdpData?.revisedBuyerPremium && pdpData?.revisedBuyerPremium <= 0) {
        return pdpPropertyFees?.buyerPremiumTxtAmt0;
      } else if (
        pdpData?.revisedBuyerPremiumPercentage &&
        pdpData?.revisedBuyerPremiumPercentage <= 0
      ) {
        return pdpPropertyFees?.buyerPremiumTxtPer0;
      } else {
        return pdpPropertyFees?.buyerPremiumDetails
          .replace('###BP_PER###', pdpData.revisedBuyerPremiumPercentage)
          .replace('###BP_AMOUNT###', pdpData.revisedBuyerPremium);
      }
    }
    return '';
  };

  const showBuyersPremimum = getBuyersPremimum() !== ''

  var showTechnologyFee =
    webTransactionFee?.replace('$', '').length === 0 ||
    webTransactionFee === '-' ||
    webTransactionFee === '$0'
      ? false
      : true;
  // const showTechnologyFee = trxFee ? false : true;

  const qtyWithLabel = (singular, plural, count) =>
    count + ' ' + (count > 1 ? plural : singular);

  const showEarnest =
    shortSaleFlag === 'N' &&
    propCategory !== 'FORECLOSURE' &&
    isPrelistAsset !== 'PREVIEW';
  return (


    <div ref={ref} className="left_side_widget mb30 tour-pdp-details p0">


<div className="col-md-12 col-lg-12 col-xl-12">

 <Row className="propertyInfoBoxHeading">
        <h3 className='propertyInfoBoxHeadingText' tabIndex="0">
       Property Fees

     </h3>

  </Row>
 {/* < h4 className='pdpHeadingMedium'>Property Fees</h4> */}
<div className= "p30">
<KeyInfoDetails
 pdpData={pdpInitData}
 pdpPropertyFees={pdpPropertyFees}
 emd={emd}
 status={status}
 getbidcenterdata={getbidcenterdata}
 isFcOnlineFlag={pdpInitData?.fcOnlineFlag}
/>
</div>
   </div>
      </div>
  );
});

PropertyFees.displayName = "PropertyFees";

export default PropertyFees;

